import styled from 'styled-components';

export const ComopnentWrapper = styled.div<{ isDeleting: boolean }>`
  transition: background-color ${({ theme }) => theme.motion.duration.quick}ms
    ${({ theme }) => theme.motion.easing.linear};
  :hover {
    background-color: ${({ theme, isDeleting }) =>
      isDeleting
        ? theme.colors.feedback.background.negative.subtle
        : theme.colors.surface.background.primary.subtle};
  }
  border-radius: ${({ theme }) => theme.border.radius.medium}px;
`;
